import React from "react";
import styles from './ContactUs.module.css';

interface Props {
    name: string,
    value?: string,
    label?: string,
    placeholder?: string,
    onInputChange: Function,
    required?: boolean,
    extraClass: any,
    showText?: boolean
}

const TextArea = ({ name, label, placeholder, onInputChange, value, required, extraClass, showText = true }: Props) => {

    return <label className={`${styles.TextInputLabel} ${extraClass ? extraClass : ''}`}>{showText ? label : ''}
        <textarea className={styles.TextAreaInputElement} name={name} value={value} placeholder={placeholder} onChange={(e) => onInputChange ? onInputChange(e.target.value) : null} required={required} />
    </label>
}

export default TextArea;